import * as FileSaver from 'file-saver';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, DropdownMenuItemType, IDropdown, ResponsiveMode } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import * as XLSX from 'xlsx';
import { IAgentProfile } from '../../../models/IAgentProfile';
import { ICountry } from '../../../models/ICountry';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import { IAgentContactInfoProps } from './IAgentContactInfoProps';
import { IAgentContactInfoState } from './IAgentContactInfoState';
initializeIcons();

export const ExportCSV = ({ csvData, fileName }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }
    return (
        <PrimaryButton text="Export" onClick={(e) => exportToCSV(csvData, fileName)} className={submitButton} iconProps={{ iconName: "Export" }} />
    )
}
const getStyles = () => {
    return {
        root: {
            maxWidth: '300px',
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '30px',
    padding: '10px',
    width: "100%", fontSize: "12px", color: '#005269'
});
const submitButton = mergeStyles({ backgroundColor: '#73797D', marginRight: "5px" });
const profileTop = mergeStyles({
    display: 'inline-block', padding: "10px", verticalAlign: 'top', minWidth: "50%", maxWidth: "100%"
});
const profileBottom = mergeStyles({
    display: 'inline-block', padding: "10px", width: "100%", verticalAlign: 'top'
});
export default class AgentContactInfo extends React.Component<IAgentContactInfoProps, IAgentContactInfoState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private CNTError: string;
    private agentProfile: IAgentProfile[];

    constructor(props: IAgentContactInfoProps, state: IAgentContactInfoState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.CNTError = '';

        this.state = {
            Countries: [],
            saving: false,
            hideDialog: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.loadCountries();
        this.agentProfile = [];
    }
    public async componentDidMount() {
        this.agentProfile.push(this.props.agentProfile);
    }
    public render(): React.ReactElement<IAgentContactInfoProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const dropdownRef = React.createRef<IDropdown>();
        const fileName = "AgentProfile_" + this.props.agentProfile.AgentName;
        return (
            <div className={panel}>
                <div style={{ textAlign: "center", backgroundColor: "#35AFD1", color: "#FFFFFF", width: "100%", padding: "5px" }}>
                    <h6>Agent Profile</h6>
                </div>
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Ok"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUpM} data-automation-id="test" text="Close" style={{ backgroundColor: '#73797D', color: '#FFFFFF' }} iconProps={{ iconName: "ChromeClose" }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
                {
                    (!this.state.saving) && (
                        <div>
                            <div className={profileTop}>
                                <div>
                                    <TextField label="Registered email address" placeholder="Registered email address" styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.EmailAddress} disabled iconProps={{ iconName: "PublicEmail" }} />
                                </div>
                                <div>
                                    <TextField label="Company Name" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.AgentName} disabled />
                                </div>
                                <div>
                                    <TextField label="VAT registration number" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.VatRegNo} disabled />
                                </div>
                                <div>
                                    <TextField label="Contact person name" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.ContactPerson} disabled />
                                </div>
                                <div>
                                    <TextField label="Email address(Contact person)" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.CPEmailAddress} disabled iconProps={{ iconName: "PublicEmail" }} />
                                </div>
                                <div>
                                    <TextField label="Phone number" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.PhoneNumber} disabled iconProps={{ iconName: "Phone" }} />
                                </div>
                            </div>
                            <div className={profileTop}>
                                <div>
                                    <TextField label="Address Line1" required styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.FirmAddress1} disabled />
                                </div>
                                <div>
                                    <TextField label="Address Line2" required styles={getStyles} maxLength={40}
                                        value={this.props.agentProfile.FirmAddress2} disabled />
                                </div>
                                <div>
                                    <TextField label="Postal Code" required styles={getStyles} maxLength={40}
                                        value={this.props.agentProfile.PostalCode} disabled />
                                </div>
                                <div>
                                    <TextField label="City" required placeholder="City" styles={getStyles}
                                        maxLength={40} value={this.props.agentProfile.City} disabled />
                                </div>
                                <div>
                                    <TextField label="State" styles={getStyles} maxLength={40}
                                        value={this.props.agentProfile.State} disabled />
                                </div>
                                <div>
                                    <Stack tokens={stackTokens} verticalAlign="end">
                                        <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                            <Dropdown
                                                id="ddCountry"
                                                placeHolder="--Select--"
                                                componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                label="Country"
                                                options={this.state.Countries}
                                                required={true}
                                                styles={{ dropdown: { minWidth: 150 } }}
                                                errorMessage={this.CNTError}
                                                selectedKey={this.props.agentProfile.CountryCode}
                                                disabled
                                            />
                                        </Stack>
                                    </Stack>
                                </div>
                            </div>
                            <div className={profileBottom}>
                                <div>
                                    <div className={profileBottom}>Services offered for </div>
                                    <div className={panel}>
                                        <div><strong>{this.props.agentProfile.ServicesOfferedFor}</strong></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    <div>
                        <div className={profileBottom}>
                            <ExportCSV csvData={this.agentProfile} fileName={fileName} /> &nbsp;&nbsp;
                            <PrimaryButton type="submit" value="Search" text="Send activation link" onClick={this.submitForm}
                                className={submitButton} iconProps={{ iconName: 'Send' }} />&nbsp;&nbsp;
                        </div>
                    </div>
                }
            </div>
        );
    }
    private loadCountries = async (): Promise<void> => {
        try {
            var result: any = [];
            result.push(
                { key: '--Select--', text: '--Select--', itemType: DropdownMenuItemType.Header });
            let countryList: ICountry[] = await this.connectionContext.get("Country");
            this.setState((prevState: IAgentContactInfoState): IAgentContactInfoState => {
                countryList = countryList.sort((a, b) => a.countryName > b.countryName ? 1 : -1)
                countryList.forEach((item: ICountry) => {
                    result.push(
                        { key: item.countryCode, text: item.countryName })
                });
                prevState.Countries = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again.");
        }
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentContactInfoState, props: IAgentContactInfoProps): IAgentContactInfoState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.props.agentProfile.EmailAddress) {
            try {
                await this.connectionContext.put(`UserActivation/${this.props.agentProfile.EmailAddress}/activationlink`, {});
                this.handleError("Activation link", "Activation link has been sent to the agent's registered email address :" + this.props.agentProfile.EmailAddress + ".");
            } catch (error) {
                this.handleError("Message", "Unable to process at the moment. Please try again.");
            }
        }
    }
    private closeModelPopUpM = (): void => {
        this.setState((previousState: IAgentContactInfoState, props: IAgentContactInfoProps): IAgentContactInfoState => {
            previousState.hideDialog = true;
            return previousState;
        });
    }
}